export * from './ngx-signature-pad/ngx-signature-pad.component';